<template>
  <div v-if="isVisible" class="flex items-center justify-between bg-br-green-light p-2 md:p-2" @click.stop>
    <p class="font-bold text-lg md:text-md">{{ benefit }}</p>
    <div class="flex items-center">
      <a
        href="#"
        class="text-gray-400 underline hover:text-gray-800 text-sm md:text-sm "
        @click.stop.prevent="toggleTooltip"
      >
        Mehr Infos
      </a>
             <div @click.stop="toggleTooltip" class="pl-[3px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#172022" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" stroke="none"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </div>
    </div>

    <!-- Tooltip Box -->
 <div
  v-if="showTooltip"
  class="absolute bottom-14 left-0 w-[99%] p-3 md:p-4 bg-white text-black text-xs md:text-sm rounded-md shadow-md border border-gray-300   sm:w-[99%] lg:w-[99%]"
>

      <button
        class="absolute top-1 md:top-2 right-1 md:right-2 text-gray-500 hover:text-gray-800 text-base md:text-lg font-bold"
        @click.stop="showTooltip = false"
      >
        x
      </button>
      <p class="leading-relaxed">{{ details }}</p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  computed: {
    benefit() {
      return this.data?.tooltip || '';
    },
    details() {
      return this.data?.description || '';
    },
    isVisible() {
       return (!!this?.data?.tooltip || !!this?.data?.description);
    },
  },
  methods: {
    toggleTooltip(event) {
      event.stopPropagation();
      this.showTooltip = !this.showTooltip;
    },
  },
};
</script>
